/* eslint-disable @typescript-eslint/no-unused-vars */
interface Config {
  API_ENDPOINT: string;
  HOST: string;
  CHAT_ENDPOINT: string;
  SOCKET_ENDPOINT: string;
  COMMUNITY_SOCKET_ENDPOINT: string;
  MIXPANEL_TOKEN?: string;
}

const dev1 = {
  API_ENDPOINT: 'https://dev1api.tagmango.com',
  HOST: 'development1web.tagmango.com',
  CHAT_ENDPOINT: 'https://testing.chat.tagmango.com',
  SOCKET_ENDPOINT: 'wss://socket.testing.tagmango.com/',
  COMMUNITY_SOCKET_ENDPOINT: 'wss://socket.testing.tagmango.com/',
};

const testing = {
  API_ENDPOINT: 'https://testing-api-v2.tagmango.com',
  HOST: 'testing.tagmango.com',
  CHAT_ENDPOINT: 'https://testing.chat.tagmango.com',
  SOCKET_ENDPOINT: 'wss://testing-api-v2.tagmango.com/',
  COMMUNITY_SOCKET_ENDPOINT: 'wss://testing-api-v2.tagmango.com/',
};

const testingWl = {
  API_ENDPOINT: 'https://testing-api-v2.tagmango.com',
  HOST: 'testingwl.tagmango.in',
  CHAT_ENDPOINT: 'https://testing.chat.tagmango.com',
  SOCKET_ENDPOINT: 'wss://testing-api-v2.tagmango.com/',
  COMMUNITY_SOCKET_ENDPOINT: 'wss://testing-api-v2.tagmango.com/',
};

const prod = {
  API_ENDPOINT: 'https://api-prod-new.tagmango.com',
  HOST: 'tagmango.com',
  CHAT_ENDPOINT: 'https://v2.new-chat-api.tagmango.com',
  SOCKET_ENDPOINT: 'wss://v2.socket.tagmango.com/',
  COMMUNITY_SOCKET_ENDPOINT: 'wss://v2.socket.tagmango.com/',
};

// let config = dev1;
// let config = testing;
let config = testingWl;
// let config = prod;

config = {
  ...config,
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT || config.API_ENDPOINT,
  HOST: process.env.REACT_APP_HOST || config.HOST,
  CHAT_ENDPOINT: process.env.REACT_APP_CHAT_ENDPOINT || config.CHAT_ENDPOINT,
  SOCKET_ENDPOINT:
    process.env.REACT_APP_SOCKET_ENDPOINT || config.SOCKET_ENDPOINT,
  MIXPANEL_TOKEN: process.env.REACT_APP_MIXPANEL_TOKEN,
  COMMUNITY_SOCKET_ENDPOINT:
    process.env.REACT_APP_COMMUNITY_SOCKET_ENDPOINT ||
    config.COMMUNITY_SOCKET_ENDPOINT,
} as Config;

export default config as Config;
